import React from 'react'
import NavModuleLinks from './subcomponents/NavModuleLinks'
import NavModuleLogo from './subcomponents/NavModuleLogo'
import NavModuleSearch from './subcomponents/search/NavModuleSearch'
import NavModuleCommunitySection from './subcomponents/community/NavModuleCommunitySection'
import { motion } from 'framer-motion'

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../lib/context'
import NavModuleAnimatingBG from './subcomponents/NavModuleAnimatingBG'
import NavModuleExpandButton from './subcomponents/NavModuleExpandButton'
import NavModuleSearchButtonCollapsed from './subcomponents/search/NavModuleSearchButtonCollapsed'


const getRouteName = (routePath) => {
    if (routePath === "/") return "home"
    if (routePath.includes("/about/")) return "about"
    if (routePath.includes("/articles/")) return "articles"
    if (routePath.includes("/community/")) return "community"

    return "home"
}

const NavModule = observer(({location}) => {
    const routeName = getRouteName(location.pathname);
    const {uiStore: {navModule__collapsed}} = useStore();
    const isArticleCollapse = navModule__collapsed && routeName === "articles";

    
    return (
        <div key="nav-module" className='nav-module'>
            <div className={`nav--grid ${isArticleCollapse ? "article-collapse" : ""}`}>
                <NavModuleLogo />
                {isArticleCollapse ? <NavModuleSearchButtonCollapsed /> : null}
                {navModule__collapsed && routeName !== "community" ? <NavModuleExpandButton /> : <NavModuleLinks routeName={routeName}/>}
            </div>

            
            
            {routeName === "articles" ? <NavModuleSearch/> : null}

            {routeName === "community" ? <NavModuleCommunitySection/> : null}
            <NavModuleAnimatingBG routeName={routeName}/>

            <style jsx>{`
                .nav--grid {
                    display: grid;
                    grid-template-columns: 54px 1fr;
                    grid-gap: 12px; 
                    height: 44px;
                    align-items: center;
                    position: relative;
                    z-index: 1;
                }

                .article-collapse {
                    display: grid;
                    grid-template-columns: 54px 1fr 40px;
                }

                .nav-module :global(.elevate) {
                    position: relative;
                    z-index: 1;
                }



                .nav-module {
                    align-items: center;
                    position: fixed;
                    z-index: 1004;
                    padding: 14px 20px;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    transition: background .3s ease-in-out;
                }


                :global(.nav-module-links) {
                    align-items: center;
                    justify-content: space-between;
                }

   

                :global(.nav-link) {
                    padding: 14px 24px;
                    margin-left: 10px;
                    border-radius: 40px;
                    background: rgba(240,240,240,.7);
                    color: #333;
                    white-space: nowrap;
                    font-size: 15px;
                    transition: background .2s ease-in-out;
                }

                :global(.nav-link-0) { 
                    margin-left: 0;
                }

                :global(.nav-link:hover) {
                    background: rgba(250,250,250,.85);
                }

                :global(.nav-link.active) {
                    background: white;
                    color: black;
                }


                :global(.nav-module-search-bar) {
                    margin: 12px 0 6px;
                    margin-bottom: 0;
                    position: relative;
                    background: #080808;
                    border-radius: 20px;
                    color: white;
                    height: 40px;
                    line-height: 0;
                    cursor: pointer;
                    z-index: 1;
                    transition: background .3s ease-in-out, color .3s ease-in-out;
                }


                :global(.nav-module-search-bar:hover) {
                    background: rgba(255,255,255,.75);
                    color: #333;
                }



                :global(.nav-module-search-bar svg) {
                    margin-right: 4px;
                    position: absolute;
                    transform: translateX(-32px) translateY(-1px);
                    height: 15px;
                }


                :global(.nav-module-search-bar:hover path) {
                    fill: #333;
                }



                :global(.nav-module-search-bar:hover circle) {
                    stroke: #333;
                }

                :global(.nav-module-search-bar .label) {
                    position: relative;
                }

                :global(.nav-module-search-bar .label::after) {
                    content: "";
                    position: absolute;
                    top: 0;
                    right: -8px;
                    display: block;
                    height: 5px;
                    width: 5px;
                    border-radius: 50%;
                    background: #54B219;
                    position: absolute;
                    opacity: 0;
                }

                :global(.nav-module-search-bar .active.label::after) {
                    opacity: 1;
                    animation: blink 2s ease infinite;
                }

                :global(.nav--community) {
                    justify-content: space-between;
                    margin-top: 12px;
                    position: relative;
                    z-index: 1;
                }


                :global(.community-link) {
                    display: inline-block;
                    padding: 12px 14px;
                    padding: 8px 12px;
                    border-radius: 40px;
                    background: black;
                    font-size: 14px;
                    font-size: 13px;
                    color: white;
                    white-space: nowrap;
                    cursor: pointer;
                    transition: all .3s ease-in-out;
                }
            
                :global(.community-link:hover) {
                    background: rgba(255,255,255,.75);
                    color: #333;
                }

                :global(.community-link.active) {
                    background: white;
                    color: #333;
                }

                @keyframes blink {
                    0% {
                    opacity: .3;
                    }
                    50% {
                    opacity: 1;
                    }
                    100% {
                        opacity: .3;
                    }
                }


                
                @media (max-width: 769px), (pointer: coarse) {
                    .nav-module {
                        // top: initial;
                        // bottom: 20px;
                        padding: 10px 12px;
                        padding-left: 12px;
                    }

                    :global(.nav-link) {
                        padding: 12px 16px;
                        margin-left: 5px;
                        font-size: 14px;

                    }
                    .nav--grid {
                        grid-template-columns: 44px 1fr;
                        grid-gap: 10px;
                        height: 40px;
                    }

                    .article-collapse {
                        grid-template-columns: 44px 1fr 35px;
                    }

                    .article-collapse :global(.expand-button) {
                        margin-left: 0;
                    }

                    :global(.nav--community) {
                        margin-top: 8px;
                    }


                    :global(.nav-module-search-bar) {
                        margin-top: 8px;
                        height: 32px;
                    }

                    :global(.nav-module-search-bar .label) {
                        font-size: 14px;
                    }

                    :global(.community-link) {
                        display: inline-block;
                        padding: 7px 7px;
                        border-radius: 40px;
                        background: black;
                        font-size: 12px;
                        color: white;
                        white-space: nowrap;
                        cursor: pointer;
                        transition: all .3s ease-in-out;
                    }
                }
            `}</style>
        </div>
    )
})

export default NavModule